module.exports = __webpack_public_path__ + "static/media/image-4.c58a7469.jpg";